// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B-Y2","select":"styles_select__211Ta"};